export {
  default as basketball,
  ReactComponent as Basketball,
} from '@assets/icons/features-and-amenities/basketball.svg'    
